import { render, staticRenderFns } from "./AboutUsIndex.vue?vue&type=template&id=0697f879&scoped=true&"
import script from "./AboutUsIndex.vue?vue&type=script&lang=js&"
export * from "./AboutUsIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0697f879",
  null
  
)

export default component.exports